import { render } from "./dol-icon-button.vue?vue&type=template&id=00aeecc6"
import script from "./dol-icon-button.vue?vue&type=script&lang=js"
export * from "./dol-icon-button.vue?vue&type=script&lang=js"

import "./dol-icon-button.vue?vue&type=style&index=0&id=00aeecc6&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__